import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchFacetsEvent } from '#/modules/search/constants/useSearchFacetsEvent';
import {
  useSearchFiltersByName,
  useSearchQuery,
} from '#/modules/search/contexts/SearchContext';
import { hasDateRange } from '#/modules/search/helpers/hasDateRange';
import { SearchPage } from '#/modules/search/pages/Search/SearchPage';
import { trackPageView } from '#/utils/analytics/track/trackPageView';

export function SearchEventsPage() {
  const { i18n } = useI18n();

  const query = useSearchQuery();
  const filters = useSearchFiltersByName();

  const location = useLocation();
  useEffect(() => {
    trackPageView('Search Events');
  }, [location.key]);

  const { eventSearchFacets } = useSearchFacetsEvent(i18n);

  return (
    <SearchPage
      searchFacets={eventSearchFacets}
      searchType="EVENT"
      showSortOptions={Boolean(query && !hasDateRange(filters))}
    />
  );
}
